import React, { useEffect, useRef } from 'react';
import './HeroCarousel.css';

const HeroCarousel = () => {
  const carouselRef = useRef(null);

  useEffect(() => {
    const initCarousel = async () => {
      // Wait for jQuery and Owl Carousel to be available
      if (!window.$ || !window.$.fn || !window.$.fn.owlCarousel) {
        // Retry after a short delay
        setTimeout(initCarousel, 100);
        return;
      }

      if (carouselRef.current && window.$.fn.owlCarousel) {
        const $ = window.$;
        $(carouselRef.current).owlCarousel({
          items: 1,
          autoplay: true,
          smartSpeed: 1500,
          center: false,
          dots: false,
          loop: true,
          margin: 0,
          nav: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          navText: [
            '<i class="bi bi-arrow-left"></i>',
            '<i class="bi bi-arrow-right"></i>'
          ],
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 1
            },
            992: {
              items: 1
            }
          }
        });
      }
    };

    initCarousel();

    return () => {
      // Cleanup
      if (carouselRef.current && window.$ && window.$.fn && window.$.fn.owlCarousel) {
        window.$(carouselRef.current).trigger('destroy.owl.carousel');
      }
    };
  }, []);

  return (
    <div className="container-fluid carousel bg-light px-0 mb-5">
      <div className="row g-0 justify-content-end">
        <div className="col-12 col-lg-12 col-xl-12">
          <div ref={carouselRef} className="header-carousel owl-carousel bg-light py-5">
            {/* Slide 1: Solar Power */}
            <div className="row g-0 header-carousel-item align-items-center">
              <div className="col-xl-6 carousel-img wow fadeInLeft" data-wow-delay="0.1s">
                <img src="/assets/BANNER-IMAGE.png" className="img-fluid w-100" alt="Lighting up lives with solar power" />
              </div>
              <div className="col-xl-6 carousel-content p-4 p-lg-5">
                <h4 className="text-uppercase fw-bold mb-4 wow fadeInRight" data-wow-delay="0.1s" style={{ letterSpacing: '3px', color: '#DE400E' }}>
                  <i className="fas fa-phone-alt me-2"></i> Call: 98657 57472
                </h4>
                <h1 className="display-4 text-capitalize mb-4 wow fadeInRight fw-bold fs-1" data-wow-delay="0.3s">
                  Lighting Up Lives With Solar Power Solutions
                </h1>
                <div className="mb-4">
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.5s">
                    <i className="fas fa-check-circle text-success me-2"></i> Premium Solar Batteries for Maximum Efficiency
                  </p>
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.6s">
                    <i className="fas fa-check-circle text-success me-2"></i> More Battery Life, More Backup Power
                  </p>
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.7s">
                    <i className="fas fa-check-circle text-success me-2"></i> Long-lasting & Maintenance Free
                  </p>
                </div>
                <a className="btn btn-primary rounded-pill py-3 px-5 wow fadeInRight mt-2" data-wow-delay="0.8s" href="#products">
                  <i className="fas fa-shopping-cart me-2"></i> Shop Solar Batteries
                </a>
              </div>
            </div>

            {/* Slide 2: Inverter Batteries */}
            <div className="row g-0 header-carousel-item align-items-center">
              <div className="col-xl-6 carousel-img wow fadeInLeft" data-wow-delay="0.1s">
                <img src="/assets/2ndbannerimage.png" className="img-fluid w-100" alt="Uninterrupted Power Solutions" />
              </div>
              <div className="col-xl-6 carousel-content p-4 p-lg-5">
                <h4 className="text-uppercase fw-bold mb-4 wow fadeInRight" data-wow-delay="0.1s" style={{ letterSpacing: '3px', color: '#DE400E' }}>
                  <i className="fas fa-bolt me-2"></i> 24/7 Power Backup
                </h4>
                <h1 className="display-4 text-capitalize mb-4 wow fadeInRight fw-bold fs-1" data-wow-delay="0.3s">
                  Uninterrupted Power for Your Home & Business
                </h1>
                <div className="mb-4">
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.5s">
                    <i className="fas fa-home text-success me-2"></i> Home Inverter Batteries
                  </p>
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.6s">
                    <i className="fas fa-industry text-success me-2"></i> Commercial & Industrial Solutions
                  </p>
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.7s">
                    <i className="fas fa-award text-success me-2"></i> 5 Years Warranty Available
                  </p>
                </div>
                <a className="btn btn-primary rounded-pill py-3 px-5 wow fadeInRight mt-2" data-wow-delay="0.8s" href="#products">
                  <i className="fas fa-plug me-2"></i> View Inverter Batteries
                </a>
              </div>
            </div>

            {/* Slide 3: Automotive Batteries */}
            <div className="row g-0 header-carousel-item align-items-center">
              <div className="col-xl-6 carousel-img wow fadeInLeft" data-wow-delay="0.1s">
                <img src="/assets/LUMINUOUS-SOLAR-BANNER.png" className="img-fluid w-100" alt="Reliable Automotive Batteries" />
              </div>
              <div className="col-xl-6 carousel-content p-4 p-lg-5">
                <h4 className="text-uppercase fw-bold mb-4 wow fadeInRight" data-wow-delay="0.1s" style={{ letterSpacing: '3px', color: '#DE400E' }}>
                  <i className="fas fa-wrench me-2"></i> Free Installation*
                </h4>
                <h1 className="display-4 text-capitalize mb-4 wow fadeInRight fw-bold fs-1" data-wow-delay="0.3s">
                  Premium Automotive Batteries for All Vehicles
                </h1>
                <div className="mb-4">
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.5s">
                    <i className="fas fa-car text-success me-2"></i> Car & SUV Batteries
                  </p>
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.6s">
                    <i className="fas fa-motorcycle text-success me-2"></i> Bike & Two-Wheeler Batteries
                  </p>
                  <p className="text-dark mb-2 wow fadeInRight" data-wow-delay="0.7s">
                    <i className="fas fa-truck text-success me-2"></i> Heavy Vehicle & Truck Batteries
                  </p>
                </div>
                <div className="d-flex flex-wrap gap-3 mt-2">
                  <a className="btn btn-primary rounded-pill py-3 px-4 wow fadeInRight" data-wow-delay="0.8s" href="#products">
                    <i className="fas fa-car me-2"></i> Automotive Batteries
                  </a>
                  <a className="btn btn-outline-primary rounded-pill py-3 px-4 wow fadeInRight" data-wow-delay="0.9s" href="tel:9865757472">
                    <i className="fas fa-phone me-2"></i> Call Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;